<script>

export default {
  name: 'email-renderer',
  props: ['value'],
 
};
</script>

<template>
  <span>{{value}}</span>
</template>
